const WRAPPER_CLASS =
  "flex flex-col items-center justify-between gap-4 px-6 py-5 text-base text-palette-gray-text sm:flex-row";

const BTN_CLASS =
  "inline-flex h-10 w-10 items-center justify-center rounded-lg " +
  "bg-white border border-palette-gray-border text-base font-medium text-palette-gray-heading " +
  "hover:bg-palette-indigo-soft hover:border-palette-indigo-ring hover:text-palette-indigo-heading " +
  "transition-all duration-200 shadow-sm hover:shadow-md " +
  "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-palette-gray-border";

const SELECT_CLASS =
  "h-10 rounded-lg border border-palette-gray-border bg-white px-4 text-base " +
  "outline-none focus:ring-2 focus:ring-palette-indigo-hover";

export default function Pagination({
  page,
  pageSize,
  itemPageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100, 200],
}) {
  const safePageSize = Math.max(1, Number(pageSize) || 10);
  const safeItemPageSize = Math.max(1, Number(itemPageSize) || safePageSize);
  const safeTotal = Math.max(0, Number(total) || 0);
  const totalPages = Math.max(1, Math.ceil(safeTotal / safeItemPageSize));

  const go = (n) => {
    const next = Math.min(Math.max(1, n), totalPages);
    onPageChange?.(next);
  };

  const Btn = ({ className = "", ...props }) => (
    <button {...props} className={`${BTN_CLASS} ${className}`} />
  );

  return (
    <div className={WRAPPER_CLASS}>
      {/* Left arrows */}
      <div className="flex items-center gap-2">
        <Btn onClick={() => go(1)} disabled={page <= 1} title="First page">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
            />
          </svg>
        </Btn>
        <Btn onClick={() => go(page - 1)} disabled={page <= 1} title="Previous page">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </Btn>
      </div>

      {/* Center info + selects */}
      <div className="flex flex-wrap items-center justify-center gap-4">
        <span className="leading-none">
          Page <span className="font-semibold">{page}</span> of{" "}
          <span className="font-semibold">{totalPages}</span>
        </span>

        <div className="flex items-center gap-2">
          <span>Go to page:</span>
          <select
            className={SELECT_CLASS}
            value={page}
            onChange={(e) => go(parseInt(e.target.value, 10))}
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-2">
          <span>Show</span>
          <select
            className={SELECT_CLASS}
            value={safePageSize}
            onChange={(e) => onPageSizeChange?.(parseInt(e.target.value, 10))}
          >
            {pageSizeOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Right arrows */}
      <div className="flex items-center gap-2">
        <Btn onClick={() => go(page + 1)} disabled={page >= totalPages} title="Next page">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Btn>
        <Btn onClick={() => go(totalPages)} disabled={page >= totalPages} title="Last page">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 5l7 7-7 7M5 5l7 7-7 7"
            />
          </svg>
        </Btn>
      </div>
    </div>
  );
}
